import withTooltip from 'framework/components/hoc/withTooltip';
import { Score } from './labelScore';

export default withTooltip(Score);
